<script setup>
import {defineProps} from 'vue'

const props = defineProps(["data"])

function generateThumbnail(name) {
  const colors = ['#10B981', '#3B82F6', '#8B5CF6', '#F59E0B', '#EF4444', '#06B6D4']
  const colorIndex = name ? name.charCodeAt(0) % colors.length : 0
  const color = colors[colorIndex]
  const initial = name ? name.charAt(0).toUpperCase() : '?'
  return { color, initial }
}

const thumbnail = generateThumbnail(props.data)
</script>

<template>
  <div class="provider-thumbnail" :style="{ backgroundColor: thumbnail.color }">
    {{ thumbnail.initial }}
  </div>
</template>

<style scoped>
.provider-thumbnail {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
}
</style>
